// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__box--_JUcq {
  display: flex;
  justify-content: center;
  width: 100%;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__imageButton--Rtfm2 {
  position: relative;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__imageButton--Rtfm2:hover .src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__counter--VAIuz {
  opacity: 1;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__imageBox--fdFDz {
  position: absolute;
  inset: 0;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__imageBox--fdFDz img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__counter--VAIuz {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  text-align: center;
  color: white;
  font-size: 14px;
  line-height: 160%;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/common/attributes/makeAttrLabel/labelMakers/image/ImgList/ImgList.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AACF;AAEA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAAF;AAEE;EACE,UAAA;AAAJ;AAIA;EACE,kBAAA;EACA,QAAA;AAFF;AAAA;EAKI,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAFJ;AAMA;EACE,kBAAA;EACA,QAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;EAEA,UAAA;EACA,oCAAA;AAPF","sourcesContent":[".box {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.imageButton {\n  position: relative;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  &:hover .counter {\n    opacity: 1;\n  }\n}\n\n.imageBox {\n  position: absolute;\n  inset: 0;\n\n  img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n}\n\n.counter {\n  position: absolute;\n  inset: 0;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  overflow: hidden;\n  text-align: center;\n  color: white;\n  font-size: 14px;\n  line-height: 160%;\n  background-color: rgba(0, 0, 0, 0.4);\n\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__box--_JUcq`,
	"imageButton": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__imageButton--Rtfm2`,
	"counter": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__counter--VAIuz`,
	"imageBox": `src-common-attributes-makeAttrLabel-labelMakers-image-ImgList-ImgList-module__imageBox--fdFDz`
};
export default ___CSS_LOADER_EXPORT___;
